module.exports = new __parcel__URL__("apply_k_faq_expanded_zh-tw.95a1fa67.webp").toString();